module.exports = __webpack_public_path__ + "img/vipjf188.d22781e1.png";